const styles = (theme) => ({
  root: {
    width: '90vw',
    maxWidth: '100%',
    height: '600px',
    display: 'flex',
    flexDirection: 'column',
    border: `3px solid white ${theme.palette.grey[400]}`,
    borderRadius: '16px',
  },
  wrapper: {
    width: '95vw',
    maxWidth: '800px',
    height: '700px',
    backgroundColor: theme.palette.common.white,
    borderRadius: '20px',
    padding: theme.spacing(4),
    position: 'relative',
    zIndex: 1202,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('lg')]: {
      maxWidth: 650,
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      maxWidth: 580,
    },
  },
})

export default styles
